import styles from "./Resultbox.module.css";
import { useState, useRef } from "react";
import drop_down from "./Icons/drop_down.png";

const ResultBox = ( props ) => {

    const result = props.obj;
    const [expanded, setExpanded] = useState(false);
    const icon = useRef()
    const sourceBlock = useRef()

    let supporting = [];
    result['support'].forEach(source => {
        supporting.push(
            <div className = {styles.source_box}>
                <p className = {styles.source_name}> <b>Source Name:</b> {source['source_name']} </p>
                <p className = {styles.source_text}><b>Supporting text from source:</b> {source['supporting_text_from_source']}</p>
                <p className = {styles.credibility_score}s> <b>Credibility Score:</b> {source['source_cred_score']} </p>
            </div>
        )        
    });

    let opposing = [];
    result['oppose'].forEach(source => {
        opposing.push(
            <div className = {styles.source_box}>
                <p className = {styles.source_name}> <b>Source Name:</b> {source['source_name']} </p>
                <p className = {styles.source_text}> <b>Opposing text from source:</b> {source['opposing_text_from_source']}</p>
                <p className = {styles.credibility_score}> <b>Credibility Score:</b> {source['source_cred_score']} </p>
            </div>
        )        
    });

    function expand() {
        if(expanded) {
            setExpanded(false);
            icon.current.style.transform = `scaleY(1)`;
            sourceBlock.current.style.display  = "none";
            sourceBlock.current.style.height  = "0";
            
        }
        else {
            setExpanded(true);
            icon.current.style.transform = `scaleY(-1)`;
            sourceBlock.current.style.display  = "flex";
            sourceBlock.current.style.height  = "fit-content";
        }
    }

    return(
        <div className = {styles.body}>
            <div className = {styles.claimBox}>
                <h2 className = {styles.claim_text}>Claim: {result['claim_text']}</h2>
                <h2 className = {styles.verdict}>Verdict: {result['truth_value']}</h2>
                <img src = {drop_down} ref = {icon} alt = "expand" className = {styles.drop_down} onClick = {expand}/>
            </div>
            <div className = {styles.sourceBlock} ref = {sourceBlock}>
                <div className = {styles.sources}>
                    <h1 className = {styles.evidence_title}>Supporting Evidence</h1>
                    {supporting}
                </div>
                <div className = {styles.sources}>
                    <h1 className = {styles.evidence_title}>Opposing Evidence</h1>
                    {opposing}
                </div>
            </div>
        </div>
    )
}

export default ResultBox;